{
  "unknown_state": "Other state",
  "financial": {
    "pending_payment": "Waiting for payment",
    "partially_paid": "Partly paid",
    "paid": "Paid",
    "partially_refunded": "Partly refunded",
    "refunded": "Refunded",
    "cancelled": "Cancelled"
  },
  "fulfillment": {
    "unfulfilled": "Not prepared yet",
    "preparing": "Preparing",
    "ready": "Packed, ready to ship",
    "shipped": "Shipped",
    "in_transit": "On the way",
    "delivered": "Delivered",
    "partial": "Partly shipped",
    "pickup_ready": "Ready for pickup",
    "picked_up": "Picked up",
    "return_requested": "Return asked for",
    "return_received": "Return received"
  },
  "parcel": {
    "pending": "Not sent yet",
    "preparing": "Preparing",
    "ready": "Packed",
    "shipped": "Shipped",
    "in_transit": "On the way",
    "delivered": "Delivered",
    "pickup_ready": "Ready for pickup",
    "picked_up": "Picked up",
    "cancelled": "Cancelled"
  },
  "review": {
    "none": "No check needed",
    "pending_review": "Waiting for a manager's check",
    "approved": "Checked — OK",
    "rejected": "Not accepted"
  },
  "tax": {
    "domestic_taxable": "10% tax (Japan)",
    "export_exempt": "Export 0%",
    "tax_free_tourist": "Tax-free (免税)",
    "non_taxable": "No consumption tax"
  },
  "evidence": {
    "not_required": "No export proof needed",
    "missing": "Export proof missing",
    "complete": "Export proof kept",
    "after_shipping": "Export proof after shipping"
  },
  "channel": {
    "web": "Web",
    "pos": "Shop",
    "ebay": "eBay",
    "whatnot": "Whatnot",
    "mercari": "Mercari",
    "other": "Other"
  },
  "delivery": {
    "ship": "Send by post / courier",
    "pickup": "Pick up at the shop"
  },
  "customer_kind": {
    "guest": "Guest",
    "registered": "Member"
  },
  "views": {
    "awaiting_bank_transfer": "Waiting for bank transfer",
    "to_prepare": "To prepare",
    "ready_to_ship": "Packed, to ship",
    "pickup_ready": "Store pickup",
    "export_missing_evidence": "Overseas — proof missing",
    "returns": "Returns and refunds",
    "flagged": "To check",
    "to_ship": "Paid, not sent yet"
  },
  "columns": {
    "number": "Order",
    "customer": "Customer",
    "total": "Total",
    "tax": "Tax",
    "payment": "Payment",
    "fulfillment": "Goods",
    "placed": "Ordered",
    "risk": "Problems",
    "actions": "What to do"
  },
  "filters": {
    "q": "Search",
    "q_placeholder": "Order number, name, e-mail, tracking number, item code",
    "channel": "Where it was sold",
    "delivery": "Delivery",
    "country": "Country",
    "evidence": "Export proof",
    "customer_kind": "Guest or member"
  },
  "list": {
    "intro": "Web and shop orders together. Tap an order to do the next step.",
    "create": "Create an order (chat / LINE)",
    "new": "New",
    "bulk_ready": "Mark as packed ({{count}})",
    "bulk_ready_title": "Mark {{count}} orders as packed?",
    "bulk_ready_consequence": "Only orders being prepared change. Each customer gets the “packed” e-mail.",
    "bulk_ready_done_one": "{{count}} order is packed",
    "bulk_ready_done_other": "{{count}} orders are packed",
    "bulk_ready_partly": "{{ok}} packed, {{failed}} could not change — open them to see why",
    "bulk_ship": "Ship ({{count}})",
    "print_slips": "Print packing slips",
    "print_invoices": "Print commercial invoices",
    "print_packing_slip_one": "Packing slip for {{count}} order is being made",
    "print_packing_slip_other": "Packing slips for {{count}} orders are being made",
    "print_commercial_invoice_one": "Commercial invoice for {{count}} order is being made",
    "print_commercial_invoice_other": "Commercial invoices for {{count}} orders are being made",
    "print_hint": "They appear under “Print” on each order in a few seconds.",
    "print_none": "None of the chosen orders go abroad.",
    "print_partly": "{{ok}} made, {{failed}} could not be made"
  },
  "steps": {
    "title": "Next steps",
    "title_pickup": "Next steps (pickup at the shop)",
    "nothing_left": "Nothing left to do for this order.",
    "label": {
      "confirm_payment": "入金確認 Money arrived",
      "start_preparing": "準備開始 Start preparing",
      "mark_ready": "準備完了 Packed",
      "ship": "発送 Ship",
      "mark_delivered": "お届け済み Delivered",
      "pickup_ready": "店頭受取可 Ready for pickup",
      "hand_over": "受け渡し済み Handed over"
    },
    "state": {
      "done": "done",
      "now": "do this now",
      "later": "not yet",
      "blocked": "not possible now"
    },
    "why": {
      "done": "Already done.",
      "needs_previous": "Do the step before first.",
      "not_paid": "The money has not arrived yet.",
      "under_review": "A manager must check this order first.",
      "cancelled": "This order is cancelled.",
      "paid_elsewhere": "Not a bank transfer — nothing to confirm here.",
      "service_says_no": "Not possible for this order right now."
    },
    "done": {
      "start_preparing": "{{number}}: preparing",
      "mark_ready": "{{number}}: packed",
      "pickup_ready": "{{number}}: ready for pickup",
      "mark_delivered": "{{number}}: delivered",
      "hand_over": "{{number}}: handed over"
    },
    "done_hint": {
      "start_preparing": "The customer sees “preparing” on their order page.",
      "mark_ready": "The customer gets the e-mail “your order is packed”.",
      "pickup_ready": "The customer gets the e-mail “you can come and pick it up”.",
      "mark_delivered": "The customer sees “delivered”.",
      "hand_over": "The order is finished."
    },
    "confirm": {
      "mark_delivered": {
        "title": "Mark everything as delivered?",
        "body": "Use this when the carrier or the customer says it arrived. It cannot be taken back."
      },
      "hand_over": {
        "title": "Did the customer take the goods?",
        "body": "Check the order number on the customer's phone first. It cannot be taken back."
      }
    }
  },
  "detail": {
    "back": "All orders",
    "load_failed": "The order could not be opened",
    "placed": "Ordered",
    "print": "Print",
    "contact": "E-mail the customer",
    "mail_subject": "About your order {{number}}",
    "cancel": "Cancel order",
    "consignment_scope": "You see the consigned cards of this order only.",
    "export_proof": "Keep the export proof",
    "export_proof_body": "This parcel goes abroad without consumption tax — keep the post office receipt or the export permit.",
    "export_proof_open": "Add the proof",
    "refund": "Give money back",
    "edit_address": "Change",
    "cancelled_refund_pending": "Cancelled — money being sent back"
  },
  "lines": {
    "title_one": "{{count}} item",
    "title_other": "{{count}} items",
    "sealed": "Sealed",
    "consigned": "Consigned (委託品)",
    "consigned_note": "On the receipt as 委託品／インボイス対象外 — the shop earns its commission only.",
    "qty_one": "{{count}} piece",
    "qty_other": "{{count}} pieces",
    "sent": "{{count}} of {{of}} sent",
    "refunded": "{{count}} refunded",
    "each": "each",
    "discount": "discount",
    "stock_now": "Now:",
    "stock_history": "Stock history",
    "unit_states": {
      "pending": "Being reserved",
      "released": "Released from the order"
    }
  },
  "totals": {
    "title": "Money",
    "subtotal": "Items",
    "discount": "Discount",
    "shipping": "Shipping",
    "duties": "Import duties paid ahead",
    "total": "Total (tax included)",
    "tax_included": "Included consumption tax",
    "received": "Received",
    "refunded": "Refunded",
    "outstanding": "Still to pay"
  },
  "payments": {
    "title": "Payment",
    "unavailable": "The payment details cannot be shown right now. The rest of the order works.",
    "none": "No payment yet.",
    "amount": "Amount",
    "received": "Arrived",
    "fee": "Card machine fee",
    "net": "The shop keeps",
    "refunded": "Refunded",
    "reference": "Payment code",
    "due": "Pay by",
    "captured_at": "Paid on",
    "notice_title": "The customer says they sent it (振込連絡)",
    "notice_line": "From {{name}}:",
    "refunds": "Refunds",
    "method": {
      "bank_transfer_manual": "Bank transfer (銀行振込)",
      "cash": "Cash",
      "edc_external": "Card machine",
      "pay_in_store": "Pay at the shop",
      "store_credit": "Store credit",
      "none": "Not chosen",
      "other": "Other way"
    },
    "status": {
      "pending": "Waiting",
      "requires_action": "Waiting for the customer",
      "processing": "Being checked",
      "authorized": "Approved",
      "captured": "Received",
      "failed": "Failed",
      "expired": "Time ran out",
      "partially_refunded": "Partly refunded",
      "refunded": "Refunded"
    },
    "refund_status": {
      "requested": "asked for",
      "pending_approval": "waiting for approval",
      "approved": "approved",
      "processing": "being paid",
      "completed": "paid back",
      "failed": "failed",
      "rejected": "not accepted"
    }
  },
  "address": {
    "title": "Send to",
    "pickup_title": "Pickup at the shop",
    "pickup_body": "The customer comes to the shop. Check the order number on their phone.",
    "none": "No address.",
    "map": "Open the map",
    "opens_new_tab": "(opens in a new tab)",
    "billing": "Billing address",
    "shipping_method": "Chosen shipping",
    "export_hint": "Goes abroad without consumption tax.",
    "export_open": "Export proof"
  },
  "timeline": {
    "title": "What happened",
    "empty": "Nothing yet.",
    "by": "by {{name}}",
    "customer_sees": "the customer sees this",
    "other": "Change recorded",
    "types": {
      "placed": "Order placed",
      "paid": "Money received (入金確認)",
      "payment_notice_received": "The customer said they sent the money",
      "payment_short": "Less money arrived than the total",
      "payment_over": "More money arrived than the total",
      "payment_due_extended": "More time given to pay",
      "variance_resolved": "Extra money settled",
      "overpayment_refunded": "Extra money paid back",
      "captured_after_cancel": "Money arrived after the cancellation",
      "preparing": "Preparing started (準備開始)",
      "ready": "Packed (準備完了)",
      "shipped": "Shipped (発送)",
      "in_transit": "On the way",
      "delivered": "Delivered (お届け済み)",
      "pickup_ready": "Ready for pickup",
      "picked_up": "Handed over at the shop",
      "pickup_recorded": "Pickup recorded at the register",
      "tracking_corrected": "Tracking number corrected",
      "cancel_requested": "The customer asked to cancel",
      "cancelled": "Cancelled",
      "refunded": "Refunded",
      "return_requested": "Return asked for",
      "return_received": "Return received",
      "return_refund_requested": "Refund for the return asked for",
      "pos_return_recorded": "Return at the register",
      "pos_void_recorded": "Sale taken back at the register",
      "void": "Payment taken back",
      "hold_expired": "The hold ran out",
      "hold_lost": "The card was not kept",
      "hold_reacquired": "The card is kept again",
      "hold_renewed": "The hold was made longer",
      "oversell_conflict": "The card was sold twice",
      "note": "Note",
      "customer_note": "Message from the customer",
      "flag_set": "Marked as a problem",
      "flag_cleared": "Problem checked",
      "document_requested": "Document asked for",
      "document_issued": "Document made",
      "export_evidence_added": "Export proof added",
      "email_resent": "E-mail sent again",
      "edited": "Order changed"
    }
  },
  "actor": {
    "customer": "the customer",
    "pos": "the register",
    "system": "the system",
    "staff": "a staff member",
    "you": "you"
  },
  "notes": {
    "title": "Notes for the team",
    "label": "Add a note",
    "placeholder": "e.g. The customer wants it wrapped",
    "hint": "Only staff see notes.",
    "add": "Add note",
    "saved": "Note added",
    "tags": "Tags",
    "tag_placeholder": "e.g. gift",
    "add_tag": "Add tag",
    "remove_tag": "Remove tag {{tag}}"
  },
  "flags": {
    "title": "Problems",
    "under_review": "This order waits for a manager's check. The goods must not be sent yet.",
    "tap_to_fix": "There is a problem — tap to see how to fix",
    "other": "Something to check",
    "fraud_risk": "Might be fraud",
    "address_mismatch": "Billing and shipping countries differ",
    "high_value": "High value order",
    "manual_review": "Held for checking",
    "first_order_international": "First order from abroad",
    "overpaid": "The customer paid too much",
    "underpaid": "The customer paid too little",
    "oversell_conflict": "The card was sold twice",
    "fix": {
      "fraud_risk": "Check the customer's details and contact them if needed. A manager decides if the order goes on.",
      "address_mismatch": "Ask the customer to confirm the address before sending.",
      "high_value": "Check the order, then a manager marks it as checked.",
      "manual_review": "Look at the notes, then a manager marks it as checked.",
      "first_order_international": "The order can go on. Check the address and the customs data.",
      "overpaid": "Pay the extra back or give store credit (a manager does this).",
      "underpaid": "Ask the customer to send the rest, or accept what arrived.",
      "oversell_conflict": "Open the problems page to decide which customer gets the card.",
      "other": "Look at the order and the notes."
    },
    "open_conflicts": "Open the problems page",
    "clear": "Checked — OK to continue",
    "clear_title": "Mark this problem as checked?",
    "clear_consequence": "The order can go on. Write what you checked.",
    "cleared": "Problem checked",
    "hold": "Hold this order for checking",
    "hold_title": "Hold this order?",
    "hold_consequence": "Nobody can send the goods until a manager checks it. Write why.",
    "held": "The order is held for checking"
  },
  "cancel": {
    "title": "Cancel {{number}}",
    "description": "Only before the goods are sent.",
    "why": "Why?",
    "reasons": {
      "customer_request": "The customer asked",
      "payment_expired": "The money did not arrive",
      "out_of_stock": "Problem with the item",
      "fraud_suspected": "Looks like fraud",
      "duplicate": "Ordered twice",
      "other": "Other"
    },
    "note": "A few words (for the history)",
    "note_required": "Write a few words for “Other”.",
    "restock": "Put the goods back on sale",
    "refund": "Give the money back",
    "consequence": "The customer gets the “cancelled” e-mail.",
    "consequence_refund": "The customer gets the “cancelled” e-mail. The refund is recorded — send the money yourself at the bank.",
    "confirm": "Cancel the order",
    "done": "{{number}} is cancelled",
    "done_hint": "The goods are back on sale.",
    "done_refund_hint": "Remember to send the money back at the bank.",
    "write_off": "What happened to the goods?",
    "write_offs": {
      "damaged": "Damaged — cannot be sold",
      "lost": "Lost — cannot be found"
    },
    "done_refund_approval": "¥{{amount}} to give back — a manager must approve it first (Money going back).",
    "done_write_off": "The goods are written off in the stock history.",
    "done_stock_pending": "The goods go back on sale in a moment."
  },
  "queue": {
    "intro": "Bank transfers to check against the bank account. The ones the customer said they sent come first.",
    "tabs": "Which transfers",
    "tab_all": "Waiting",
    "tab_overdue": "Past the deadline",
    "to_pay": "To pay",
    "due": "Pay by",
    "no_due": "No deadline",
    "overdue": "Past the deadline — the hold will be let go",
    "days_left": "{{d}} days {{h}} h left",
    "hours_left": "{{h}} h left",
    "notice": "Customer says (振込連絡)",
    "no_notice": "Nothing yet",
    "has_slip": "Slip attached",
    "remind": "Remind",
    "remind_aria": "Send the transfer details again for {{number}}",
    "reminded": "{{number}}: the transfer details were e-mailed again",
    "cancel": "No money → cancel",
    "cancel_aria": "Cancel {{number}} (no money arrived)",
    "empty": "No bank transfers to check.",
    "empty_overdue": "No transfer is past its deadline."
  },
  "transfer": {
    "title": "入金確認 — the money arrived",
    "description": "{{number}} · {{name}}",
    "expected": "Still to pay",
    "notice": "The customer said {{name}} sent {{amount}}.",
    "amount": "Amount that arrived",
    "short": "{{amount}} less than the total — what now?",
    "short_hold": "Wait for the rest (the order keeps waiting)",
    "short_capture_partial": "Accept what arrived (the order becomes partly paid)",
    "short_contact": "You can e-mail the customer from the order page.",
    "over": "{{amount}} more than the total. The order becomes paid; settle the extra on the order page (pay back or store credit).",
    "received_at": "When it arrived (Japan time)",
    "received_at_hint": "As on the bank statement.",
    "payer": "Name of the sender",
    "reference": "Bank reference",
    "reference_hint": "Optional — the line of the bank statement.",
    "slip": "Transfer slip (optional)",
    "slip_from_customer": "The customer's slip is already attached.",
    "note": "Note (optional)",
    "confirm": "Confirm {{amount}} received",
    "confirm_hold": "Record {{amount}} and wait for the rest",
    "confirm_plain": "Confirm",
    "blocker": {
      "amount_invalid": "Type the amount that arrived (whole yen).",
      "choose_short": "Less money arrived — choose what to do first."
    },
    "wait_upload": "Wait until the slip is uploaded.",
    "no_payment": "This order has no bank transfer waiting.",
    "load_failed": "The order could not be loaded.",
    "customer_mail": "The customer gets the 注文確定 e-mail and the receipt.",
    "outcome": {
      "captured": "{{number}}: paid",
      "captured_within_tolerance": "{{number}}: paid (a tiny difference was accepted)",
      "captured_partial": "{{number}}: partly paid",
      "captured_overpaid": "{{number}}: paid — more than the total arrived",
      "held_underpaid": "{{number}}: recorded — waiting for the rest"
    }
  },
  "ship": {
    "title": "発送 — ship {{number}}",
    "description": "Everything that is left goes in this parcel.",
    "partial_note": "Only the ticked pieces go — the rest can be sent later.",
    "what": "What goes in the parcel",
    "qty_of": "{{qty}} / {{of}}",
    "fewer": "One less of {{title}}",
    "more": "One more of {{title}}",
    "carrier": "Carrier",
    "other_carriers": "Other carriers",
    "carriers_failed": "The carriers could not be loaded. Try again.",
    "tracking": "Tracking number (scan or type)",
    "tracking_hint": "Scan the barcode on the label.",
    "tracking_example": "Looks like {{example}}.",
    "tracking_ok": "Looks right.",
    "tracking_unusual": "This does not look like this carrier's number (e.g. {{example}}). Check it — you can still ship.",
    "test_link": "Test the tracking link",
    "no_tracking": "No tracking number",
    "no_tracking_title": "Ship without a tracking number?",
    "no_tracking_consequence": "The customer cannot follow the parcel. Use this only for a carrier without tracking.",
    "no_tracking_confirm": "Ship without number",
    "no_tracking_set": "Shipping without a tracking number.",
    "add_tracking": "Add a number",
    "from": "Leaves from",
    "when": "Sent at (Japan time)",
    "when_hint": "Now, unless it left earlier.",
    "zonos_id": "Zonos declaration ID",
    "zonos_hint": "US parcels $100–2,500 by Japan Post need the prepaid duty (on the label).",
    "high_value": "Worth ¥100,000 or more",
    "hv_photos": "Photos of the item and the box taken",
    "hv_insurance": "Insure the full value",
    "hv_not_insurable": "This carrier has no insurance — choose another one",
    "hv_signature": "Signature on delivery",
    "override": "Manager: send anyway because…",
    "override_hint": "Kept in the history.",
    "confirm": "Ship",
    "confirm_partial": "Ship these pieces",
    "problem": {
      "no_lines": "Tick at least one piece.",
      "no_carrier": "Choose a carrier.",
      "no_tracking": "Scan or type the tracking number (or choose “No tracking number”).",
      "high_value": "Tick the three checks for a parcel worth ¥100,000 or more."
    },
    "done": "{{number}} is shipped",
    "done_partial": "{{number}}: part of the order is shipped",
    "done_hint": "The customer gets an e-mail with the tracking link. A wrong number can be fixed for 10 minutes.",
    "done_hint_no_tracking": "The customer gets the “shipped” e-mail."
  },
  "customs": {
    "title": "Customs (read only)",
    "us_ddp": "USA: must be DDP — Japan Post parcels of $100–2,500 need the Zonos prepaid duty.",
    "loading": "Loading the customs data…",
    "unavailable": "The customs data cannot be shown right now.",
    "incoterm": "Duties",
    "incoterms": {
      "DDP": "Paid by the shop (DDP)",
      "DDU": "Paid by the customer (DDU)"
    },
    "form": "Form",
    "value": "Declared value",
    "weight": "Weight",
    "grams": "{{g}} g",
    "duties_prepaid": "Duties paid ahead",
    "zonos": "Zonos",
    "zonos_missing": "Not entered yet",
    "warning_other": "Check the customs data.",
    "print_invoice": "Print commercial invoice",
    "print_cn": "Print CN22 / CN23",
    "printing": "The document is being made — it appears under “Print” in a few seconds."
  },
  "parcels": {
    "title_one": "Parcel",
    "title_other": "{{count}} parcels",
    "track": "Track",
    "no_tracking": "No tracking number",
    "shipped_at": "Shipped",
    "in_transit_at": "On the way",
    "delivered_at": "Delivered",
    "pickup_ready_at": "Ready for pickup",
    "picked_up_at": "Picked up",
    "mark_in_transit": "配送中 On the way",
    "mark_delivered": "お届け済み Delivered",
    "deliver_title": "Mark this parcel as delivered?",
    "deliver_consequence": "The customer sees “delivered”. It cannot be taken back.",
    "fix": "Fix the number",
    "fix_title": "Fix the tracking number",
    "fix_description": "The customer gets the new link.",
    "fix_save": "Save the number",
    "fixed": "Tracking number fixed",
    "customer_sees": "The customer's order page shows it.",
    "done_in_transit": "Parcel on the way",
    "done_delivered": "Parcel delivered"
  },
  "pickups": {
    "intro": "Orders the customer collects at the shop. Compare the order number on the customer's phone, then hand over.",
    "load_failed": "The pickups could not be loaded.",
    "waiting_one": "Ready — waiting for the customer ({{count}})",
    "waiting_other": "Ready — waiting for the customer ({{count}})",
    "none_waiting": "Nobody to wait for.",
    "to_prepare_one": "To prepare ({{count}})",
    "to_prepare_other": "To prepare ({{count}})",
    "none_to_prepare": "Nothing to prepare.",
    "pay_at_counter": "Pays at the counter.",
    "use_pos": "Take the payment at the register — it hands over there.",
    "scan": {
      "title": "Scan the customer's QR",
      "label": "QR code or its text",
      "hint": "Scan the QR on the customer's phone (the \"ready for pickup\" e-mail opens it), or type what is under it.",
      "find": "Find the order",
      "invalid": "This QR is not a pickup order of this shop. Ask for the order number and compare it with the list below.",
      "too_short": "The code is too short — scan it again.",
      "not_ready": "Not ready for pickup yet — prepare it first.",
      "already": "Already handed over.",
      "cancelled": "This order was cancelled — do not hand anything over.",
      "confirm_body": "The QR matches this order. Hand over the goods — this cannot be undone.",
      "handed_over": "{{number}} handed over"
    }
  },
  "bulk_ship": {
    "title_one": "Ship {{count}} order",
    "title_other": "Ship {{count}} orders",
    "intro": "Choose the carrier once, then scan each tracking number — Enter goes to the next order.",
    "tracking_for": "Tracking number for {{number}}",
    "skip": {
      "high_value": "Worth ¥100,000 or more — ship it from its own page.",
      "not_ready": "Not ready to ship."
    },
    "open": "Open the order",
    "row_done": "Shipped — {{number}}",
    "sending": "Sending",
    "running": "Shipping…",
    "confirm_one": "Ship {{count}} order",
    "confirm_other": "Ship {{count}} orders",
    "done_one": "{{count}} order shipped",
    "done_other": "{{count}} orders shipped",
    "partly": "{{ok}} shipped, {{failed}} not — see the rows in red"
  },
  "draft": {
    "title": "Create an order (chat / LINE)",
    "intro": "For a customer who buys by chat. The cards are kept for 3 days; the customer gets the tracking link and the bank account by e-mail.",
    "customer": "Customer",
    "email": "Customer e-mail",
    "language": "Customer's language",
    "language_hint": "The e-mails go out in this language.",
    "locales": {
      "en": "English",
      "ja": "日本語",
      "th": "ไทย",
      "zh_Hant": "繁體中文",
      "zh_Hans": "简体中文"
    },
    "items": "Items",
    "scan": "Scan or search an item",
    "scan_hint": "Item code, barcode, certificate number or name.",
    "no_items": "No item yet.",
    "remove": "Remove {{title}}",
    "price_hint": "Prices, shipping and tax are worked out by the shop system when the order is made.",
    "delivery": "Delivery",
    "payment": "Payment",
    "payment_ship": "Payment: bank transfer (銀行振込), 3 days.",
    "address": {
      "country": "Country",
      "country_hint": "2 letters, e.g. JP, US",
      "postal_code": "Postal code",
      "region": "Prefecture / state",
      "city": "City",
      "address1": "Street and number",
      "address2": "Building, room",
      "name": "Name",
      "phone": "Phone",
      "name_kana": "Name in kana",
      "company": "Company"
    },
    "note": "Note (optional)",
    "note_hint": "Shown on the order for the team.",
    "create": "Create the order",
    "creating": "Creating…",
    "problem": {
      "email": "Type the customer's e-mail.",
      "lines": "Add at least one item.",
      "address": "Type the country, street and name."
    },
    "done": "{{number}} is created",
    "done_hint": "The customer gets the e-mail with the tracking link and the bank account.",
    "done_title": "{{number}} is created",
    "done_body": "The cards are kept for the customer. You can paste the link into the chat.",
    "tracking_link": "The customer's order page",
    "tracking_once": "This link is shown only now. The customer also has it in the e-mail.",
    "copy": "Copy the link",
    "copied": "Link copied",
    "open": "Open the order",
    "another": "Create another order"
  },
  "conflicts": {
    "intro": "Problems to look at: a card sold twice, orders held for checking, stock numbers that do not match.",
    "tabs": "Kinds of problems",
    "tab": {
      "sold-twice": "Sold twice",
      "to-check": "Orders to check",
      "stock-differences": "Stock differences"
    },
    "show_closed": "Show the decided ones too",
    "load_failed": "The problems could not be loaded.",
    "none": "No card was sold twice.",
    "none_body": "When the web and the shop sell the same card at once, it shows up here.",
    "none_to_check": "No order waits for a check.",
    "to_check_intro": "Orders with a problem or waiting for a manager (also shop sales made while the internet was down).",
    "stock_intro": "The nightly check compares the stock numbers with the history.",
    "open_movements": "Open the stock history",
    "summary": "{{winner}} and {{loser}} got the same card",
    "status": {
      "open": "Needs a decision",
      "resolved": "Decided",
      "dismissed": "Closed"
    },
    "back": "All problems",
    "title": "The same card was sold twice",
    "what": {
      "order_paid": "{{winner}} paid first. {{loser}} was paid too, but the card was already gone.",
      "offline_commit": "{{loser}} was sold at the register while the internet was down; {{winner}} had the card already.",
      "external_paid": "{{loser}} came from another shop after {{winner}} had the card."
    },
    "side": {
      "winner": "Has the card",
      "loser": "Did not get the card"
    },
    "open_order": "Open the order",
    "timeline": "What happened",
    "event": {
      "winner": "{{label}}",
      "loser": "{{label}}",
      "detected": "The system noticed it",
      "resolved": "Decided"
    },
    "policy": {
      "external_paid_wins": "Rule used: a paid sale wins over a card that was only kept (not paid).",
      "first_paid_wins": "Rule used: whoever paid first keeps the card."
    },
    "fix": "What to do",
    "decision": {
      "keep_winner": "Cancel the other order and tell the customer",
      "dismiss": "Mark as checked",
      "swap_to_loser": "Give the card to the other customer",
      "both_cancelled": "Cancel both"
    },
    "note": "What did you decide and why?",
    "note_hint": "Kept in the history.",
    "note_required": "Write a few words.",
    "done": {
      "keep_winner": "Decided — cancel the other order and tell the customer",
      "dismiss": "Marked as checked",
      "swap_to_loser": "The card goes to the other customer",
      "both_cancelled": "Both are cancelled"
    },
    "cancel_other": "Open the other order to cancel it"
  },
  "refund": {
    "title": "Give money back · {{number}}",
    "description": "Recorded here — you send the money yourself (bank, cash). For goods that come back, use “Start a return”.",
    "confirm": "Record ¥{{amount}} back",
    "confirm_plain": "Record the money back",
    "nothing": "No money was received on this order, so nothing can be given back.",
    "which_payment": "From which payment?",
    "left": "Can give back up to",
    "already": "already given back",
    "amount": "Amount to give back",
    "why": "Why?",
    "reasons": {
      "price_adjustment": "Price corrected",
      "goodwill": "Sorry gesture",
      "overpayment": "The customer paid too much",
      "other": "Other",
      "order_cancelled": "Order cancelled",
      "return": "Goods came back",
      "tax_free_refund": "Tax-free refund"
    },
    "note": "A few words (for the history)",
    "how": "How does the money go back?",
    "methods": {
      "original": "The way it was paid",
      "bank_transfer": "Bank transfer to the customer",
      "cash": "Cash at the counter",
      "store_credit": "Store credit (valid 6 months)",
      "edc_manual": "Cancel on the card machine"
    },
    "consequence": {
      "original": "Send the money back the way the customer paid, then press “Record it”.",
      "bank_transfer": "Send the transfer at your bank, then press “The money was sent” with the bank's number.",
      "cash": "Hand the cash to the customer, then press “Record it”.",
      "store_credit": "The credit is added to the customer's account at once.",
      "edc_manual": "Cancel the payment on the card machine, then write the slip number."
    },
    "blocker": {
      "amount_invalid": "Type the amount in whole yen.",
      "amount_too_high": "That is more than can be given back on this payment.",
      "note_required": "Write a few words for “Other”.",
      "account_incomplete": "Fill in every box of the customer's account (7-digit number), or leave them all empty."
    },
    "done": "Money back recorded for {{number}}",
    "done_approval": "A manager must approve it before the money is sent.",
    "destination": {
      "title": "Customer's bank account",
      "hint": "Leave empty if you do not have it yet — the refund waits for it.",
      "bankName": "Bank",
      "branchName": "Branch",
      "accountType": "Account type",
      "accountNumber": "Account number (7 digits)",
      "accountName": "Account holder (カナ)",
      "types": {
        "futsu": "普通 (ordinary)",
        "toza": "当座 (current)"
      }
    }
  },
  "refunds": {
    "title": "Money going back",
    "open_one": "{{count}} to do",
    "open_other": "{{count}} to do",
    "phase1": "Card refunds come later. For now the shop sends the money itself and records it here.",
    "step": {
      "waiting_approval": "Waiting for approval",
      "hand_cash": "Hand the cash",
      "enter_terminal_reference": "Cancel on the machine",
      "waiting_destination": "Waiting for the account",
      "transfer_money": "Send the transfer",
      "done": "Money sent",
      "rejected": "Not accepted",
      "failed": "Did not work"
    },
    "next": {
      "waiting_approval": "Another manager must approve this refund.",
      "hand_cash": "Hand the cash to the customer, then record it.",
      "enter_terminal_reference": "Cancel it on the card machine, then write the slip number.",
      "waiting_destination": "Waiting for the customer's bank account — they enter it on their order page (not possible yet: give it back by cash or store credit instead if they cannot wait).",
      "transfer_money": "Send the transfer at your bank, then record the bank's number.",
      "done": "Done — the customer got the money back.",
      "rejected": "This refund was not accepted.",
      "failed": "This refund did not work — look at the note or try again."
    },
    "approve": "Approve",
    "reject": "Do not approve",
    "done_approve": "Refund approved",
    "done_reject": "Refund not approved",
    "approve_title": "Approve this refund?",
    "approve_consequence": "The money can then be sent to the customer.",
    "reject_title": "Do not approve this refund?",
    "reject_consequence": "No money is given back. The reason is kept in the history.",
    "record": {
      "bank": "The money was sent",
      "other": "Record it"
    },
    "record_title": "Record the money back",
    "record_description": {
      "bank": "Write the number your bank gave for the transfer.",
      "other": "Write the receipt or slip number."
    },
    "record_save": "Save",
    "recorded": "Recorded — the money is back with the customer",
    "recorded_hint": "The customer gets the e-mail and the document by themselves.",
    "reference_required": "Write the number from the bank or the slip.",
    "reference": {
      "bank": "Bank transfer number",
      "other": "Receipt / slip number"
    },
    "reference_hint": "So you can find it again later.",
    "when": "When",
    "amount": "Amount",
    "show_account": "Show the account",
    "show_account_hint": "Each look is recorded.",
    "no_account": "The customer's account is not known yet — ask the customer.",
    "ref": "No.",
    "tax_part": "consumption tax in it"
  },
  "returns": {
    "title": "Returns",
    "intro": "Goods customers send back: approve, receive the parcel, check each item, give the money back.",
    "start": "Start a return",
    "none": "No returns yet.",
    "created": "Return opened for {{number}}",
    "created_hint": "Approve it when you agree — the customer gets the instructions by e-mail.",
    "start_title": "Start a return · {{number}}",
    "start_description": "Only items that were sent and not given back yet.",
    "start_confirm": "Open the return",
    "none_chosen": "Choose at least one item.",
    "what": "Which items come back?",
    "why": "Why?",
    "reasons": {
      "damaged_in_transit": "Damaged on the way",
      "not_as_described": "Not as described",
      "wrong_item": "Wrong item sent",
      "sealed_unopened_7d": "Sealed, unopened (within 7 days)",
      "legal_8day": "Within 8 days (law)",
      "other": "Other"
    },
    "description": "What the customer said",
    "override": "Why it is accepted anyway",
    "override_hint": "Outside the return rules — a manager can accept it with a reason.",
    "consigned_note": "Consigned card: the consignor's payout for it is taken back.",
    "approve_title": "Approve the return · {{number}}",
    "approve_description": "The customer gets an e-mail with how to send it back.",
    "approve": "Approve",
    "approved": "Return approved",
    "approved_hint": "The customer got the instructions.",
    "postage": "Who pays the postage back?",
    "paid_by": {
      "shop": "The shop pays",
      "customer": "The customer pays"
    },
    "instructions": "Instructions for the customer",
    "instructions_placeholder": "e.g. Send it by Click Post to our shop address.",
    "receive": "返品受領 — The parcel is back",
    "receive_title": "Parcel back · {{number}}",
    "receive_description": "Check each item: back on sale, or damaged. The refund is worked out next.",
    "receive_confirm": "Save and work out the refund",
    "received": "Return received",
    "received_refund": "¥{{amount}} to give back — see “Money going back”.",
    "received_hint": "The refund is being worked out.",
    "damage_note_required": "Write what is wrong with each damaged item.",
    "arrived": "How many arrived",
    "arrived_n_one": "{{count}} arrived",
    "arrived_n_other": "{{count}} arrived",
    "state": "State",
    "disposition": {
      "restock": "Back on sale",
      "damage": "Damaged"
    },
    "condition_note": "What is wrong / notes",
    "location": "Put it back at",
    "location_hint": "Where the item goes on the shelf.",
    "location_default": "The usual place",
    "refund_amount": "Refund",
    "refund_tax": "consumption tax",
    "henkan_yes": "A 返還インボイス (refund invoice) will be issued for this refund.",
    "henkan_no": "No 返還インボイス is needed for this refund.",
    "refund_status": {
      "pending": "Not asked yet — press “Ask for the refund again”.",
      "failed": "Asking for the refund did not work — try again.",
      "requested": "Recorded — send the money and record it.",
      "approval_required": "Waiting for a manager's approval.",
      "refunded": "Money sent back."
    },
    "status": {
      "requested": "Asked for",
      "approved": "Approved — waiting for the parcel",
      "rejected": "Not accepted",
      "received": "Parcel back",
      "closed": "Done"
    },
    "reject_reason": "Reason:",
    "ask_refund": "Ask for the refund again",
    "refund_asked": "Refund asked for",
    "reject": "Do not accept",
    "rejected": "Return not accepted",
    "reject_title": "Do not accept this return?",
    "reject_consequence": "The customer gets an e-mail with your reason.",
    "columns": {
      "order": "Order",
      "status": "State",
      "reason": "Why",
      "items": "Items",
      "refund": "Refund",
      "requested": "Asked"
    }
  },
  "edit": {
    "title": "Change address · {{number}}",
    "description": "Before the goods are sent.",
    "description_paid": "Already paid: a new country can change the tax and the postage — the system works it out again and tells you.",
    "save": "Save the changes",
    "saved": "Changes saved",
    "saved_hint": "The customer's documents use the new details.",
    "stale": "Someone changed this order a moment ago. Close and open it again.",
    "fill_required": "Fill in the boxes marked as needed.",
    "required": "Needed",
    "postal_hint": "7 digits fill in the rest of the address.",
    "postal_found": "Address filled in — add the house number.",
    "postal_unknown": "This postal code was not found — type the address.",
    "country_warning": "A different country after payment changes the tax (Japan 10% ↔ export 0%) and the postage. You will see the result before anything else happens.",
    "undo_address": "Put the old address back",
    "close": "OK",
    "outcome_title": "What changed",
    "tax_changed": "Tax: {{before}} → {{after}}",
    "total_changed": "Total:",
    "adjustment": {
      "balance_due": "The customer must pay more:",
      "refund_due": "To give back to the customer:"
    },
    "notices": {
      "shipping_rate_changed": "The postage changed to the cheapest way for the new address.",
      "other": "The system changed something else — see the order history."
    },
    "payment_updated": "The amount to transfer was updated for the customer.",
    "no_money_change": "Tax and total stay the same."
  },
  "documents": {
    "title": "Documents",
    "page_title": "Documents · {{number}}",
    "back": "Back to {{number}}",
    "create": "Make a document",
    "none": "No documents yet.",
    "making": "The document is being made — it opens by itself.",
    "media_down": "The document system does not answer right now. Try again in a moment.",
    "failed": "The document could not be made. Try again.",
    "same_file": "This document was made before",
    "same_file_hint": "The same file opens — nothing new was made.",
    "t_number": "Registration number on receipts:",
    "t_number_missing": "Not set — Settings › Tax",
    "t_number_placeholder": "Test number — change it in Settings › Tax",
    "types": {
      "ryoshusho": "領収書 (receipt)",
      "kani_invoice": "適格簡易請求書 (simple invoice)",
      "tekikaku_invoice": "適格請求書 (invoice with name)",
      "henkan_invoice": "返還インボイス (refund invoice)",
      "commercial_invoice": "Commercial invoice (export)",
      "packing_slip": "納品書 (packing slip)",
      "customs_cn22": "Customs form CN22",
      "customs_cn23": "Customs form CN23",
      "customs_declaration": "Customs form (CN22/CN23)",
      "refund_note": "Refund note",
      "tax_free_slip": "免税 record",
      "taxfree_explanation": "免税 explanation",
      "refund_evidence": "Refund proof"
    },
    "type_help": {
      "ryoshusho": "The usual receipt.",
      "kani_invoice": "Receipt with the registration number and tax.",
      "tekikaku_invoice": "For a company — needs the buyer's name.",
      "packing_slip": "Goes into the parcel.",
      "commercial_invoice": "For customs abroad.",
      "customs_declaration": "The customs sticker data."
    },
    "unavailable": {
      "not_paid": "Only after payment.",
      "not_export": "Only for parcels abroad."
    },
    "status": {
      "requested": "Being made",
      "ready": "Ready",
      "failed": "Could not be made",
      "superseded": "Replaced by a newer one"
    },
    "to": "To: {{name}}",
    "hash": "Fingerprint",
    "version": "Version {{n}}",
    "open": "Open",
    "download": "Download",
    "resend": "E-mail again",
    "resent": "E-mail sent again",
    "create_title": "Make a document · {{number}}",
    "create_description": "The system makes the PDF with the shop's details and keeps it 7 years.",
    "create_confirm": "Make and open",
    "which": "Which document?",
    "recipient": "Buyer's name (宛名)",
    "recipient_hint": "Company or person as it must appear.",
    "problem": {
      "recipient_required": "適格請求書 needs the buyer's name (宛名)."
    },
    "with_prices": "Show prices on the packing slip",
    "language": "Language of the document",
    "language_hint": "The customer's language is chosen.",
    "preview": "Document",
    "n_of": "{{n}} of {{total}}",
    "previous": "Previous",
    "next": "Next",
    "print": "Print",
    "close": "Close",
    "loading": "Opening the document…",
    "bulk_title": {
      "packing_slip_one": "Packing slip for {{count}} order",
      "packing_slip_other": "Packing slips for {{count}} orders",
      "commercial_invoice_one": "Commercial invoice for {{count}} order",
      "commercial_invoice_other": "Commercial invoices for {{count}} orders"
    },
    "bulk_description": "Each order's document is made (the same file if it exists). Then print them one after another.",
    "bulk_print_one": "Print {{count}} document",
    "bulk_print_other": "Print {{count}} documents",
    "bulk_progress": "Documents made",
    "bulk_state": {
      "waiting": "Waiting",
      "making": "Being made",
      "ready": "Ready",
      "skipped": "Not needed",
      "failed": "Could not be made"
    },
    "bulk_open": "Print one after another"
  }
}
